/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';

/**
 * Component for testing LTI Advantage Names and Roles requests
 */
@Component({
  selector: 'bulb-lti-names-and-roles',
  templateUrl: './lti-names-and-roles.component.html',
  standalone: false,
})
export class LtiNamesAndRolesComponent {

  authUrl: string = 'https://saltire.lti.app/platform/token/bcc806b1c41d6ac172ea03f2d067bfb7';

  requestUrl: string = 'https://saltire.lti.app/platform/membership/context/bcc806b1c41d6ac172ea03f2d067bfb7';

  clientId: string = 'saltire.lti.app';

  response: string;

  constructor(
    private http: HttpClient,
  ) { }

  sendRequest() {

    const encodedAuthUrl = encodeURIComponent(this.authUrl);
    const encodedRequestUrl = encodeURIComponent(this.requestUrl);
    this.response = '';

    this.http
      .get('devtools/ltiNamesAndRoles'
        + `?authUrl=${encodedAuthUrl}&namesUrl=${encodedRequestUrl}&clientId=${this.clientId}`)
      .subscribe(
        (response) => {
          this.response = JSON.stringify(response, null, 2);
        },
        (error) => {
          const errorString = JSON.stringify(error, null, 2);
          this.response = `Error: ${errorString}`;
        },
      );
  }
}
